export default __webpack_public_path__ + "static/media/elevate-pyl-2.2c10b6b9.png";